export const Estados = {
  0: "Pendiente de aprobación",
  1: "Aprobado",
  2: "Pendiente de documentación",
  3: "Bloqueado",
  4: "Rechazado",
};

export const EstadosNames = Object.freeze({
  PENDIENTE_APROBACION: 0,
  APROBADO: 1,
  PENDIENTE_DOCUMENTACION: 2,
  BLOQUEADO: 3,
  RECHAZADO: 4
});

export const estadosArr = Object.keys(Estados).map((key) => {
  return { value: Number(key), estado: Estados[key] };
});
